import { render } from "./UploadPlanilhas.vue?vue&type=template&id=232b1c5a&scoped=true&ts=true"
import script from "./UploadPlanilhas.vue?vue&type=script&lang=ts"
export * from "./UploadPlanilhas.vue?vue&type=script&lang=ts"

import "./UploadPlanilhas.vue?vue&type=style&index=0&id=232b1c5a&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232b1c5a"]])

export default __exports__